import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { PostPresenceReportRequest } from "../../requests/orchestrator-patient/post-presence-report.request";
import { PresenceReportResponse } from "../../responses/orchestrator-patient/presence-report.response";

@Injectable({
  providedIn: 'root'
})
export class PresenceReportService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public postReportPDF(request: PostPresenceReportRequest): Observable<PresenceReportResponse> {
    let uri = `PresenceReport`;

    return this.httpClient.post<PresenceReportResponse>(environment.urlApiOrchestratorPatient + uri, request, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}